import baseApi from './baseApi'

export const activityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGameReports: builder.query({
      query: ({ userId, gameTitle }) => `games_data?user_id=${userId}`,
      transformResponse: (response, meta, arg) => {
        return response.ques
          .filter((d) => d[2].toLowerCase() === arg.gameTitle.toLowerCase())
          .map((d) => JSON.parse(d[6][0]))
      },
      providesTags: ['GameReports'],
    }),
    saveGameReport: builder.mutation({
      query: (report) => ({
        url: 'games_data',
        method: 'POST',
        body: report,
      }),
      invalidatesTags: ['GameReports'],
    }),
  }),
})

// auto-generated based on the defined endpoints
export const { useGetGameReportsQuery, useSaveGameReportMutation } = activityApi
